<template>
  <div>
    <snap-link
      class="mb-2 block"
      v-for="transport in available"
      :key="transport"
      @click="$emit('select', transport)"
    >
      Send New Code By {{ METHODS_LABELS[transport as TransportEnum] }}
    </snap-link>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { TransportEnum } from "@/types/graphql";

@Options({
  props: {
    available: Array<TransportEnum>,
  },

  emits: ["select"],
})
export default class AvailableMethodSelector extends Vue {
  available!: Array<TransportEnum>;
  TransportEnum = TransportEnum;

  get METHODS_LABELS(): Record<TransportEnum, string> {
    return {
      [TransportEnum.Email]: "Email",
      [TransportEnum.Sms]: "Text",
    };
  }
}
</script>
